import Config from './config';
import tools from './tools';
import vjsSrv from './vjsSrv';
import eventsSrv from './events';
import vimmiPI from '../plugins/vimmiPI';
import { PLAYER_EVENTS } from 'vimmi-web-utils/cjs/postMessage';
import { PMWrap } from './PMWrap';
import $logger from '../logger';

export class AppPreview {
  constructor() {
    this.active = false;
    this.ended = false;
    this.viewedTime = 0;
    this.modal = null;
    this.timerEl = null;
    this.preview_info = null;
    this.options = {};
    this.isLive = false;
    this.preview_info = {
      preview_start: 0,
      preview_end: 0
    };
  }

  isShowPreview(asset) {
    return !!asset.preview;
  }


  hide() {
    this.hideModal();
    if (this.active) {
      $logger.p('AppPreview/hide').log(this);

      this.active = false;
      this.viewedTime = 0;
      this.ended = false;
      this.isLive = false;
      this.preview_info = {
        preview_start: 0,
        preview_end: 0
      };
      this.asset = null;

      vjsSrv.vjsPlayer.removeClass('previewed-content');
      vjsSrv.vjsPlayer.removeClass('preview-content-end');

      vjsSrv.vjsPlayer.off('timeupdate', this.timeUpdate);
      vjsSrv.vjsPlayer.off('loadedmetadata', this.onMetadata);
    }
  }

  hideModal() {
    if (this.modal) {
      this.modal.close();
      this.modal = null;
      this.timerEl = null;
      if (Config.get('params.controls') && this.isChangedControls) {
        vjsSrv.controls(true);
        this.isChangedControls = false;
      }
    }
  }

  show(asset) {
    $logger.p('AppPreview/show').log(this, asset);
    this.hide();
    this.asset = asset;
    this.preview_info = asset.preview_info;
    this.isLive = asset.isLive;

    this.showModal();

    vjsSrv.vjsPlayer.off('loadedmetadata', this.onMetadata);
    if ((this.preview_info.preview_end - this.preview_info.preview_start) <= 1) {
      vjsSrv.vjsPlayer.one('loadedmetadata', this.onMetadata);
    } else {
      vjsSrv.vjsPlayer.on('timeupdate', this.timeUpdate);
    }
  }

  showModal(isLive = null, ended = null, preview_info = null) {
    if (!this.modal) {
      this.active = true;
      vjsSrv.vjsPlayer.addClass('previewed-content');
      this.isLive = isLive !== null ? isLive : this.isLive;
      this.preview_info = preview_info || this.preview_info;
      this.ended = ended !== null ? ended : this.ended;
      this.modal = vjsSrv.vjsPlayer.createModal('', { uncloseable: true });
      this.updateText();
      this.modal.addClass('vjs-preview-modal');
      if (Config.get('params.controls')) {
        vjsSrv.controls(true); /// because modal hide it automatically
        this.isChangedControls = true;
      }
    }
  }

  updateText() {
    if (this.modal) {
      if (this.ended) {
        this.modal.contentEl_.innerHTML = `<span class="modal-text preview-end">${vjsSrv.vjsPlayer.localize(this.preview_info?.time_left_mess || 'Preview time remaining - ')} <span class="preview-timer">00:00</span></span>`;
      } else {
        const time = this.calculateTime();
        this.modal.contentEl_.innerHTML = `<span class="modal-text">${vjsSrv.vjsPlayer.localize('Preview time remaining - ')} <span class="preview-timer">${time}</span></span>`;
      }
      this.timerEl = this.modal.contentEl_.querySelector('.preview-timer');
    }
  }

  onMetadata() {
    Preview.onPreviewEnded();
  }

  calculateTime() {
    if (this.isLive) {
      let second = (this.preview_info.preview_end - this.preview_info.preview_start) - (this.viewedTime || 0);
      return tools.toHHMMSS(second);
    } else {
      let current = vjsSrv.vjsPlayer.currentTime();
      let second = this.preview_info.preview_end - (this.preview_info.preview_start > current ? this.preview_info.preview_start : current);
      return tools.toHHMMSS(second);
    }
  }

  onPreviewEnded() {
    if (this.active) {
      this.modal.addClass('modal-preview-end');
      vjsSrv.vjsPlayer.addClass('preview-content-end');
      vjsSrv.vjsPlayer.pause();
      if (!this.isLive) {
        vjsSrv.vjsPlayer.currentTime(this.preview_info.preview_start);
      }
      this.updateText();
      // this.modal.contentEl_.innerHTML = `<span class="modal-text preview-end">${vjsSrv.vjsPlayer.localize(this.preview_info?.time_left_mess || 'Preview time remaining - ')} <span class="preview-timer">00:00</span></span>`;
      if (vjsSrv.vjsPlayer.isFullscreen()) {
        vjsSrv.vjsPlayer.exitFullscreen();
      }
      if (Config.get('params.controls')) {
        vjsSrv.controls(false);
      }

      if (this.viewedTime >= (this.preview_info.preview_end - this.preview_info.preview_start)) {
        eventsSrv.emit(PLAYER_EVENTS.PREVIEW_FINISHED, {
          stream_time: vimmiPI.getActiveAsset().get('extraData.stream_time'),
          item: this.asset.item,
          fullyWatched: this.viewedTime >= (this.preview_info.preview_end - this.preview_info.preview_start)
        });

        if (!Config.get('params.imported')) {
          PMWrap.inst().sendWrappedEvent(PLAYER_EVENTS.PREVIEW_FINISHED, {
            stream_time: vimmiPI.getActiveAsset().get('extraData.stream_time'),
            item: this.asset.item
          });
        }
      }
    }
  }

  timeUpdate() {
    let $this = Preview;
    if (!$this.active) {
      return;
    }
    if (!vimmiPI.getActiveAsset()) {
      return;
    }
    if (vimmiPI.getActiveAsset().get('state.changingAudio')) {
      return;
    }
    // $logger.p('AppPreview/timeUpdate').info({
    //   duration: vjsSrv.vjsPlayer.duration(),
    //   currentTime: vjsSrv.vjsPlayer.currentTime(),
    //   eventsState: Config.get('eventsState'),
    //   state: vimmiPI.getActiveAsset() && vimmiPI.getActiveAsset().get('state'),
    //   extraData: vimmiPI.getActiveAsset().get('extraData'),
    //   context: this
    // });
    $this.viewedTime = vimmiPI.getActiveAsset().get('extraData.stream_time') || 0;
    if ($this.ended) {
      if (!vjsSrv.vjsPlayer.paused()) {
        vjsSrv.vjsPlayer.pause();
      }
      return;
    }
    if ($this.isLive) {
      if ($this.viewedTime >= ($this.preview_info.preview_end - $this.preview_info.preview_start)) {
        $this.ended = true;
        $this.onPreviewEnded();
      }
    } else {
      if (vjsSrv.vjsPlayer.currentTime() < $this.preview_info.preview_start) {
        vjsSrv.vjsPlayer.currentTime($this.preview_info.preview_start + $this.viewedTime);
        return;
        // } else if (vjsSrv.vjsPlayer.currentTime() >= $this.preview_end) {
      } else if ($this.viewedTime >= ($this.preview_info.preview_end - $this.preview_info.preview_start)) {
        $this.ended = true;
        $this.onPreviewEnded();
        return;
      }
    }

    $this.timerEl.innerHTML = $this.calculateTime($this.isLive, $this.preview_info.preview_start, $this.preview_info.preview_end);
  }
}

const Preview = new AppPreview();

export default Preview;